import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';
import { noop } from 'ui-components/default-props/noop';
import { emptyObject } from 'ui-components/default-props/empty';
import { MessageDescriptorPropType } from '../../../../../prop-types/intl';

import { ExportOptions, ExportOptionsValues } from '../../enums/export-options-enum';
import style from '../../export-records-modal.module.less';

export const RecordTypeOptionGroup = ({ messages = emptyObject, primaryRecordsOrLineItems, onExportRecordTypeChanged = noop }) => {
  return (
    <div className={style.group}>
      <div className={style['group-head']}>
        <FormattedMessage defaultMessage='How would you like to export these?' description='exportRecordsModal.headerTwo' id='FkFAnN' />
      </div>
      <div className={style['group-options']}>
        <RadioCheckList>
          <RadioCheckListItem
            id={ExportOptions.EXPORT_PRIMARY_RECORDS}
            isChecked={primaryRecordsOrLineItems === ExportOptions.EXPORT_PRIMARY_RECORDS}
            onChecked={() => onExportRecordTypeChanged(ExportOptions.EXPORT_PRIMARY_RECORDS)}
          >
            <FormattedMessage {...messages.recordType} />
          </RadioCheckListItem>
          <RadioCheckListItem
            id={ExportOptions.EXPORT_PRIMARY_RECORDS_AND_LINE_ITEMS}
            isChecked={primaryRecordsOrLineItems === ExportOptions.EXPORT_PRIMARY_RECORDS_AND_LINE_ITEMS}
            onChecked={() => onExportRecordTypeChanged(ExportOptions.EXPORT_PRIMARY_RECORDS_AND_LINE_ITEMS)}
          >
            <FormattedMessage {...messages.recordTypeWithLineItem} />
          </RadioCheckListItem>
        </RadioCheckList>
      </div>
    </div>
  );
};

RecordTypeOptionGroup.propTypes = {
  messages: PropTypes.shape({
    recordType: MessageDescriptorPropType,
    recordTypeWithLineItem: MessageDescriptorPropType,
  }),
  primaryRecordsOrLineItems: PropTypes.oneOf(ExportOptionsValues).isRequired,
  onExportRecordTypeChanged: PropTypes.func,
};
